export var EReportCustomerFrom;
(function (EReportCustomerFrom) {
    EReportCustomerFrom[EReportCustomerFrom["\u4F9B\u5E94\u94FE"] = 1] = "\u4F9B\u5E94\u94FE";
    EReportCustomerFrom[EReportCustomerFrom["\u5546\u57CE"] = 2] = "\u5546\u57CE";
    EReportCustomerFrom[EReportCustomerFrom["\u81EA\u4E3B\u6DFB\u52A0"] = 3] = "\u81EA\u4E3B\u6DFB\u52A0";
})(EReportCustomerFrom || (EReportCustomerFrom = {}));
export var EReportCustomerType = [
    { id: '', label: '全部' },
    { id: EReportCustomerFrom['供应链'], label: '供应链' },
    { id: EReportCustomerFrom['商城'], label: '商城' },
    { id: EReportCustomerFrom['自主添加'], label: '自主添加' },
];
export default EReportCustomerFrom;
